// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__EQJc-","search":"Settings_search__3PQFm","filter":"Settings_filter__2sX5H"};